import i18n from '../../language/index'
let o = {}

function data({
  id,
  tips,
  textTips
}) {
  this.p = Object.assign(this.p, {
    [`${id}_tips`]: tips,
    [`${id}_textTips`]: textTips,
    [`${id}_tipsTextSpec`]: {
      underline: true,
      text: i18n.t('widgets_basic_plugin_code_p_2742')
    }
  })
}

export default {
  changeTextTips: function (isInit) {
    let textTips = '',
      tips = '',
      id = this.listArr.id
    switch (this.listArr.type) {
      case 'default':
        if (!isInit) this.p.removeEl.bind(this)(undefined, id)
        if (!isInit) this.p.removeEl.bind(this)('$body', id)
        textTips = i18n.t('widgets_basic_plugin_code_index_3039')
        tips = i18n.t('widgets_basic_plugin_code_p_2743')
        break
      case 'head':
        textTips = i18n.t('widgets_basic_plugin_code_p_2744')
        this.p.createEl.bind(this)(undefined, id)
        if (!isInit) this.p.removeEl.bind(this)('$body', id)
        tips = i18n.t('widgets_basic_plugin_code_p_2745')
        break
      case 'body':
        textTips = i18n.t('widgets_basic_plugin_code_p_2746')
        this.p.createEl.bind(this)('$body', id)
        if (!isInit) this.p.removeEl.bind(this)(undefined, id)
        tips = i18n.t('widgets_basic_plugin_code_p_2745')
        break
    }
    data.bind(this)({
      id,
      tips,
      textTips
    })
  },
  createEl: function (type = '$head', id) {
    let $e = document.querySelector(`${type.substring(1)}`)
    let $s = document.querySelector(`#basic_plugin_code_${type.substring(1)}_${id}`)
    if ($s == null) {
      $s = $e.insertAdjacentElement("beforeEnd", document.createElement("script"))
      $s.setAttribute('id', `basic_plugin_code_${type.substring(1)}_${id}`)
    }
    let v = this.listArr.content.replace(/<script\b.*?(?:>)/gi, '')
    v = v.replace(/<\/script>/gi, '')
    $s.innerHTML = v
  },
  removeEl: function (type = '$head', id) {
    const $el = document.querySelector(`#basic_plugin_code_${type.substring(1)}_${id}`)
    if ($el) $el.remove();
  },
  initData: function (v) {
    if (!Reflect.has(o, `${this.listArr.id}-activeNames`)) {
      o = Object.assign(o, {
        [`${this.listArr.id}-activeNames`]: []
      })
    }
    if (v) o = Object.assign(o, {
      [`${this.listArr.id}-activeNames`]: v
    })
    return o
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_plugin_code/p.js